import http from './http';

export async function listPendingAccounts() {
  const { data } = await http.get('/admin/pending-accounts');
  return data;
}

export async function approvePendingAccount(id) {
  const { data } = await http.post(`/admin/pending-accounts/${id}/approve`, {});
  return data;
}

export async function rejectPendingAccount(id) {
  const { data } = await http.post(`/admin/pending-accounts/${id}/reject`, {});
  return data;
}

